import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription, combineLatest, takeWhile } from 'rxjs';
import { BookingService } from 'src/app/service/booking.service';
import { HomeService } from 'src/app/service/home.service';
import { PaymentService } from 'src/app/service/payment.service';
import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorModalComponent } from '../../error-modal/error-modal.component';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'trpx-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss'],
})
export class BookingComponent implements OnInit {
  upcomingBookingData: any[] = [];
  completedBookingData: any[] = [];
  cancelledBookingData: any[] = [];

  upcomingItemsToDisplay = 10;
  completedItemsToDisplay = 10;
  cancelledItemsToDisplay = 10;

  bookingItems: any;
  componentData: any[] = [];
  isLoading: boolean = false;

  activeTab: string = '';
  upcomingTab: boolean = true;
  completedTab: boolean = false;
  cancelledTab: boolean = false;

  selectedCountry!: string | null;
  selectedCurrency!: string | null;

  booking_idPass: any;
  isDownloading: boolean = false;

  private dataSubscription: Subscription = new Subscription();
  modalRef?: BsModalRef;

  fileToUpload: File | null = null;
  fileType: string = 'image';
  progress: number | undefined;
  @ViewChild('messageTemplate') messageTemplate!: TemplateRef<any>;
  errorModalRef?: BsModalRef;
  cancellationReasons: any;
  cancelReason: boolean = false;
  selectedCancelReason: string | null = null;
  isLoadingReason: boolean = false;


  constructor(
    private bookingService: BookingService,
    public homeService: HomeService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private paymentService: PaymentService,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.selectedCountry = localStorage.getItem('Trip_Country') ?? '';
      this.selectedCurrency = localStorage.getItem('Trip_Currency') ?? '';
    }

    this.dataSubscription = combineLatest([
      this.homeService.country$,
      this.homeService.currency$,
    ])
      .pipe()
      .subscribe(([country, currency]) => {
        if (country && currency) {
          this.selectedCountry = country;
          this.selectedCurrency = currency;
          // this.countryRelatedAPIs();
        }
      });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const data = localStorage.getItem('token');
      if (data) {
      } else {
        this.router.navigate([`/`]);
      }
    }
    this.countryRelatedAPIs();
    this.activeTab = 'upcoming';
  }

  upComingTab() {
    this.activeTab = 'upcoming';
    this.upcomingTab = true;
    this.completedTab = false;
    this.cancelledTab = false;
  }

  bookedTab() {
    this.activeTab = 'completed';
    this.upcomingTab = false;
    this.completedTab = true;
    this.cancelledTab = false;
  }
  cancelTab() {
    this.activeTab = 'cancelled';
    this.upcomingTab = false;
    this.completedTab = false;
    this.cancelledTab = true;
  }

  getBookingDetails(currency: any, status: any) {
    this.isLoading = true;
    this.bookingService.getBookingDetails(currency, status).subscribe(
      (result) => {
        console.log('result', result);
        if (status == 'completed') {
          this.completedBookingData = result;
          this.completedBookingData.forEach((item, index) => {
            item.isOpen = index === 0;
          });
          this.isLoading = false;
        }
        if (status == 'upcoming') {
          this.upcomingBookingData = result;
          this.upcomingBookingData.forEach((item, index) => {
            item.isOpen = index === 0;
          });
          this.isLoading = false;
        }

        if (status == 'cancelled') {
          this.cancelledBookingData = result;
          this.cancelledBookingData.forEach((item, index) => {
            item.isOpen = index === 0;
          });
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  grievanceListData: any;
  grievanceListId: any;
  getGrievanceList(booking_item_id: any) {
    this.bookingService
      .getGrievanceList(booking_item_id)
      .subscribe((result) => {
        let data = result;
        console.log("data", data)
        this.grievanceListData = result;
        this.grievanceListId = result[0]?.id;
        console.log("this.grievanceListId", this.grievanceListId)
      });
  }

  formatStatus(status: string | null): string {
    if (!status) return '';
    return status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }

  toggleAccordion(item: any): void {
    item.isOpen = !item.isOpen;
  }

  downloadTicket(booking_id: any) {
    this.isDownloading = true;
    this.paymentService
      .downloadSingleTicket(
        booking_id,
        this.selectedCountry,
        this.selectedCurrency
      )
      .subscribe(
        (blob: Blob) => {
          if (isPlatformBrowser(this.platformId)) {
            this.isDownloading = false;
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `Ticket-${booking_id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
          }
        },
        () => {
          this.isDownloading = false;
        }
      );
  }

  downloadAllTicket(booking_id: any): void {
    this.paymentService
      .downloadZipFile(booking_id, this.selectedCountry, this.selectedCurrency)
      .subscribe(
        (data: Blob) => {
          if (isPlatformBrowser(this.platformId)) {
            // Handle the downloaded zip file data here
            const blobUrl = URL.createObjectURL(data);
            // Use the URL to create a link and trigger download
            const downloadLink = document.createElement('a');
            downloadLink.href = blobUrl;
            downloadLink.download = `Ticket-${booking_id}.zip`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
        },
        (error) => {
          console.error('Error downloading zip file:', error);
        }
      );
  }

  countryRelatedAPIs() {
    this.getBookingDetails(this.selectedCurrency, 'completed');
    this.getBookingDetails(this.selectedCurrency, 'upcoming');
    this.getBookingDetails(this.selectedCurrency, 'cancelled');
  }

  loadMore(type: string) {
    if (type === 'upcoming') {
      this.upcomingItemsToDisplay += 5;
    } else if (type === 'completed') {
      this.completedItemsToDisplay += 5;
    } else if (type === 'cancelled') {
      this.cancelledItemsToDisplay += 5;
    }
  }

  selectedItem: any;
  selectedReason: any;
  cancellationCharges: any;
  isCancellable: boolean = false;
  refundPreference: string = 'wallet';

  openModal(template: TemplateRef<any>, item: any, items: any) {
    this.selectedItem = item; // Store the clicked item

    if (items?.booking?.purchased_source === 'ondc') {
      this.bookingService
        .getOndcCharges(
          this.selectedItem?.product_id,
          this.selectedItem?.booking,
          this.selectedItem?.ticket
        )
        .subscribe((result) => {
          if (result) {
            this.cancelReason = true;
            this.cancellationReasons = result
            this.modalRef = this.modalService.show(template);
          }
        });
    } else {
      this.refundApiCall(template)
    }

  }


  refundApiCall(template?: TemplateRef<any>) {
    this.bookingService
      .getCancellationCharges(
        this.selectedItem?.product_id,
        this.selectedItem?.booking,
        this.selectedItem?.ticket,
        this.selectedReason
      )
      .subscribe({
        next: (result) => {
          this.isLoadingReason = false;
          this.cancelReason = false;

          if (result) {
            this.isCancellable = result?.is_cancellable;
            this.cancellationCharges = result;
            this.refundAmount = result?.refund_amount;

            if (template) {
              this.modalRef = this.modalService.show(template);
            }
          }
        },
        error: (error) => {
          this.isLoadingReason = false;

          // toaster message
          this.toastr.error(
            'Unable to fetch cancellation details. Please try again.',
            'Error'
          );

          console.error('Cancellation API failed', error);
        }
      });
  }

  refundAmount: any;
  closeModal() {
    this.showConfirmationMessage = false;
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  confirmCancel() {
    // Add your cancel logic here
    console.log('Canceled');
    if (this.refundPreference === 'wallet') {
      const data = {
        is_wallet: true,
        refund_amount: this.refundAmount,
        product_id: this.selectedItem?.product_id,
        booking_id: this.selectedItem?.booking,
        ticket_id: this.selectedItem?.ticket,
      };
      // Handle wallet refund logic
      this.confirmCancellation(data);
    } else if (this.refundPreference === 'original') {
      // Handle refund to original payment method
      const data = {
        payment_option: true,
        refund_amount: this.refundAmount,
        product_id: this.selectedItem?.product_id,
        booking_id: this.selectedItem?.booking,
        ticket_id: this.selectedItem?.ticket,
      };
      this.confirmCancellation(data);
    }
    // this.closeModal();
  }
  confirmMesage: any;
  isConfirmCancelled: any;
  showConfirmationMessage: boolean = false;

  confirmCancellation(data: any) {
    this.bookingService.postConfirmCancellation({ data }).subscribe((res) => {
      console.log('result', res);
      if (res?.cancelled === true) {
        // this.closeModal();
        this.showConfirmationMessage = true
        this.isConfirmCancelled = res?.cancelled;
        this.confirmMesage = res?.message;
        // this.openCancellModal(this.confirmMesage);
      } else {
        // this.closeModal();
        this.showConfirmationMessage = true
        this.isConfirmCancelled = res?.cancelled;
        this.confirmMesage = res?.message;
        // this.openCancellModal(this.confirmMesage);
      }
    });
  }

  openCancellModal(message: string) {
    this.confirmMesage = message;
    this.modalService.show(this.messageTemplate, {
      class: 'modal-dialog-centered modal-md' // or any class you want
    });
  }

  contactWhatsApp() {
    const phoneNumber = '1234567890'; // Replace with your actual WhatsApp number
    const message = encodeURIComponent(
      `Hello, I need assistance with my booking: ${this.selectedItem?.booking}`
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  }
  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

  handleIcon(files: FileList): void {
    const file = files.item(0);
    const formData = new FormData();

    if (file) {
      this.fileToUpload = file;
      this.fileType = file.type;
    } else {
      this.fileToUpload = null;
      this.fileType = '';
    }

    if (this.fileToUpload) {
      formData.append('document', this.fileToUpload);
      formData.append('document_type', 'image');
    }

    this.bookingService.postGallery(formData).subscribe(
      (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            this.progress = Math.round(
              (100 * event.loaded) / (event.total || 1)
            );
            break;

          case HttpEventType.Response:
            this.progress = 0;
            this.toastr.success('Upload Success!', 'Added Successfully!');
            // this.openErrorModal(
            //   'Copy Failed',
            //   'Couldn’t copy the code. Try again.',
            //   true,
            //   3000,
            //   'success'
            // );
            this.helpFormData.image = event.body.document;
            break;
        }
      },
      (error) => {
        this.progress = 0;
        this.toastr.error('Upload Failed', 'Something went wrong.');
        // this.openErrorModal(
        //   'Copy Failed',
        //   'Couldn’t copy the code. Try again.',
        //   true,
        //   3000,
        //   'error'
        // );
      }
    );
  }

  submitHelpForm(form: NgForm): void {
    if (form.invalid) {
      this.toastr.warning('Please fill out all required fields.');
      Object.values(form.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    const payload = {
      booking_item_id: this.selectedBookingItemId,
      message: this.helpFormData.message,
      subject: this.helpFormData.subject,
      ondc_item_id: this.selectedPaxData.ondc_item_id,
      booking_pax_ids: this.selectedPaxData.booking_pax_ids,
      images: this.helpFormData.image ? [this.helpFormData.image] : [],
      grievance_id: this.grievanceListId
    };
    if (this.selectedPaxData.booking_pax_ids?.length) {
      this.bookingService.postGrievanceCreateAppend(payload).subscribe((res) => {
        let data = res;
        this.toastr.success('Form Submitted!', 'Help Form Submitted Successfully!');
      });
    } else {
      this.toastr.warning('Please select any ticket')
    }
  }

  resetHelpForm() {
    this.helpFormData = {
      message: '',
      subject: '',
      image: null,
    };
    this.fileType = '';
    const fileInput = document.getElementById('uploadImg') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  helpOpenId: number | null = null;

  selectedPaxData: {
    ondc_item_id: string[];
    booking_pax_ids: string[];
  } = {
      ondc_item_id: [],
      booking_pax_ids: [],
    };
  selectedBookingItemId: any = '';

  toggleHelpSection(itemId: any) {
    this.selectedBookingItemId = itemId;
    this.helpOpenId = this.helpOpenId === itemId ? null : itemId;

    this.getGrievanceList(this.selectedBookingItemId);
  }
  helpFormData: {
    message: string;
    subject: string;
    image: File | null;
  } = {
      message: '',
      subject: '',
      image: null,
    };

  onCheckboxChange(event: any, pax: any) {
    const checked = event.target.checked;

    if (checked) {
      // Add values
      if (!this.selectedPaxData.ondc_item_id.includes(pax.ondc_item_id)) {
        this.selectedPaxData.ondc_item_id.push(pax.ondc_item_id);
      }
      if (!this.selectedPaxData.booking_pax_ids.includes(pax.id)) {
        this.selectedPaxData.booking_pax_ids.push(pax.id);
      }
    } else {
      // Remove values
      this.selectedPaxData.ondc_item_id =
        this.selectedPaxData.ondc_item_id.filter(
          (id) => id !== pax.ondc_item_id
        );
      this.selectedPaxData.booking_pax_ids =
        this.selectedPaxData.booking_pax_ids.filter((id) => id !== pax.id);
    }
  }

  openErrorModal(
    headData?: any,
    subHeadData?: any,
    autoClose?: any,
    autoCloseTime?: number,
    modalColor?: string
  ) {
    const initialState = {
      headData: headData,
      subHeadData: subHeadData,
      autoClose: autoClose, // Enable auto-close
      autoCloseTime: autoCloseTime, // Close after 3 seconds
      modalColor: modalColor,
    };

    this.errorModalRef = this.modalService.show(ErrorModalComponent, {
      class: 'modal-dialog-centered error-modal-style',
      animated: true,
      ignoreBackdropClick: true,
      initialState,
    });
  }

  // messages: { [itemId: number]: { sender: string; text: string }[] } = {};

  // onFileChange(event: any) {
  //   const file = event.target.files[0];
  //   this.helpFormData.image = file;
  // }

  // submitHelpForm(itemId: number) {
  //   // Add user message to chat (simulate sending)
  //   if (!this.messages[itemId]) this.messages[itemId] = [];

  //   this.messages[itemId].push({
  //     sender: 'user',
  //     text: `${this.helpFormData.heading}: ${this.helpFormData.subject}`,
  //   });

  //   // Simulate client response after a delay
  //   setTimeout(() => {
  //     this.messages[itemId].push({
  //       sender: 'client',
  //       text: 'Thanks for reaching out. We will get back to you shortly.',
  //     });
  //   }, 1000);

  //   // Reset form
  //   this.helpFormData = {
  //     heading: '',
  //     subject: '',
  //     image: null,
  //   };
  // }

  onReasonChange(reasonId: string) {
    console.log('Selected reason ID:', reasonId);
    this.selectedReason = reasonId;
  }

  submitReason() {
    this.isLoadingReason = true;
    this.refundApiCall()
  }

}
